<div class="remove-product__modal">
  <h6 class="remove-product__modal-text" i18n="@@CONFIRM_REMOVE_ITEM_FROM_CART">
    Are you sure you want to remove this product from your shopping cart?
  </h6>
  <div class="remove-product__modal-buttons">
    <button type="button" class="btn btn-secondary" (click)="closeModal()" i18n="@@CANCEL">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="confirmCartProductRemoval()" i18n="@@ACCEPT">Accept</button>
  </div>
</div>
